import React from 'react';
import { useTranslation } from "react-i18next";

const ReviewCard = ({ image, name, designation, message }) => {
    const { t } = useTranslation("safety");
    return (
        <div className="bg-black p-4 rounded-lg shadow-lg flex flex-col border border-[#FFFFFF1A] mt-[29.58px] max-w-[380px]">
            <div className="flex flex-col items-center gap-4 px-[31px] md:flex-row md:items-start">
                <img
                    src={image}
                    alt={name}
                    className="w-16 h-16 rounded-full"
                />
                <div className="text-center md:text-left">
                    <h3 className="body-regular-2 text-color-2">{t(name)}</h3>
                    <p className="title-small-2 text-color">{t(designation)}</p>
                </div>
            </div>
            <p className="body-medium text-left text-color-3 mt-6 md:px-[31px] mb-[41.84px]">{t(message)}</p>
        </div>
    );
};

const ReviewSection = () => {
    const reviews = [
        // First Column (Upward)
        [
            {
                image: "/assets/cardimg1.png",
                name: "olivia_skye",
                designation: "ceo_imagine_agency",
                message: "dfense_helped_reduce_downtime"
            },
            {
                image: "/assets/cardimg4.png",
                name: "benjamin_paul",
                designation: "operations_manager_apex_mining",
                message: "dfense_partner_success"
            },
        ],
        // Second Column (Downward)
        [
            {
                image: "/assets/cardimg2.png",
                name: "steven_richard",
                designation: "director_operations_ecomine",
                message: "dfense_transformed_safety"
            },
            {
                image: "/assets/cardimg5.png",
                name: "christina_blair",
                designation: "cofounder_ceo_codewrights",
                message: "dfense_new_safety_standard"
            },

        ],
        // Third Column (Upward)
        [
            {
                image: "/assets/cardimg3.png",
                name: "christopher_adam",
                designation: "cto_datasystems_llc",
                message: "dfense_tailored_solutions"
            },
            {
                image: "/assets/cardimg6.png",
                name: "matthew_lee",
                designation: "cfo_vista_media_group",
                message: "dfense_exceptional_support"
            },

        ]
    ];
    const { t } = useTranslation("safety");


    return (
        <div className="relative mx-auto px-[30px] max-w-[1220px] ">
            <div className="flex flex-col items-center text-center">
                <div className="title-small font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit">
                    <span className="gradient-text">
                        {t("verified_reviews_title")}
                    </span>
                </div>

                <h2 className="web-heading-card-4 text-color-2 mb-4">
                    {t("customers_reviews_title")}
                </h2>

                <p className="body-large-2 text-color mb-6">
                    {t("trusted_by_customers")}
                </p>
            </div>


            <div className="flex flex-col md:flex-row justify-between gap-4 gap-y-1 max-w-[1220px]">
                {reviews.map((column, columnIndex) => (
                    <div key={columnIndex} className="flex flex-col">
                        {column.map((review, reviewIndex) => (
                            <div

                            >
                                <ReviewCard {...review} />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewSection;